"use strict";var e=require("./isNonNullObject.cjs");exports.isNonEmptyObject=function(t){return e.isNonNullObject(t)&&Object.keys(t).length>0};
//# sourceMappingURL=isNonEmptyObject.cjs.map
